/**
 * @section 4.2.1.3
 */
import { Theme } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
// import { useAppContext } from '../../cms/context/AppCtxProvider';
import SearchIcon from "@material-ui/icons/Search";
import axios from "axios";
import { t } from "i18next";
import localforage from "localforage";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDebounce } from "react-use";
import { SearchResult } from "./../../apihooks/useSearch";
import { useAppContext } from "./../../context/AppCtxProvider";
import useCurrentUser from "./../../context/UserContext";
import useCreateLink from "./../../hooks/useCreateLink";
import { mea_t } from "./../../tplutils/utils";
import getElementTypePage from "./../../utils/getElementTypePage";
import tmodel from "./../../utils/translate";
import { getFileApiURL } from "./../../utils/url-utils";
import { makeThemedStyles } from "./../../viewcomponents/utils";
import SearchResults from "./SearchResults";

type PeriodOption = { name: string };
type TopElementOption = { id: string; JS_ATTR?: string; name?: string };
const useStyles = makeThemedStyles("SearchBar", (theme: Theme) => {
  return {
    iconButton: {
      width: "20px",
      height: "20px",
      marginLeft: "15px",
      marginRight: "15px",
      color: "#111111",
      "& img, & .MuiIconButton-label img": {
        width: "1.33em",
        height: "1.33em",
        filter: "brightness(0) !important",
      },
    },
    searchComponent: {
      marginTop: "0px",
      paddingTop: "0px",
      float: "left",
    },
    searchBar: {
      animation: "$expand 0.5s",
      animationIterationCount: 1,
      backgroundColor: "#FAFAFA",
      color: "black",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "39.2em",
      height: "4.94em",
      borderRadius: "2.28em",
      caretColor: "rgba(0, 169, 163, 1)",
      /*
            borderTopLeftRadius: '30px 50%',
            borderBottomLeftRadius: '30px 50%',
            borderTopRightRadius: '30px 50%',
            borderBottomRightRadius: '30px 50%'
            */
    },
    closingSearchBar: {
      animation: "$shrink 0.2s",
      animationIterationCount: 1,
      backgroundColor: "#FAFAFA",
      color: "black",
      display: "flex",
      alignItems: "center",
      right: "100px",
      left: "100px",
      justifyContent: "space-between",
      borderTopLeftRadius: "30px 50%",
      borderBottomLeftRadius: "30px 50%",
      borderTopRightRadius: "30px 50%",
      borderBottomRightRadius: "30px 50%",
      visibility: "hidden",
    },
    typing: {
      outline: "1px solid #29baa4",
    },
    searchInput: {
      marginLeft: "1.17em",
      marginRight: "1.17em",
      borderRight: "none",
      width: "100%",
      border: "none",
      backgroundColor: "rgba(0,0,0,0)",
      outline: "none",
    },
    resultsContainer: {
      position: "absolute",
      width: "39.16em",
      height: "60.9em",
      marginTop: "25px",
      backgroundColor: "#FAFAFA",
      boxShadow: "2px 2px 2px lightgray",
      borderRadius: "25px",
      overflow: "hidden",
      overflowY: "auto",
      "&::-webkit-scrollbar": { display: "none" },
    },
    recentOpenedItemsContainer: {
      display: "flex",
      margin: "1.6em 0px 2.4em 0px",
    },
    recentOpenedItemsTextContainer: {
      width: "18.12em",
      display: "flex",
      flexDirection: "column",
    },
    results: {
      margin: "2.74em",
      marginLeft: "2.74em",
      marginRight: "30px",
    },
    resultTitle: {
      marginTop: "0px",
      color: "gray",
      fontSize: "1.4857em",
      lineHeight: "2.31em",
      fontWeight: 500,
      marginBottom: "0px",
    },
    recentResultTitle: {
      color: "gray",
      fontSize: "1.6em",
      lineHeight: "1.428em",
    },
    linkContainer: {
      marginBottom: "2.4em",
      display: "block",
    },
    resultName: {
      color: "rgb(17,94,103)",
      fontSize: "1.6em",
      lineHeight: "2.14em",
      margin: "0.571em 0px",
    },
    recentResultName: {
      color: "#283b57",
      fontSize: "1.6em",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontWeight: 500,
      lineHeight: "1.071em",
    },
    clearIcon: {
      margin: "0",
      marginLeft: "16px",
      marginRight: "16px",
      position: "relative",
      color: "rgba(137, 142, 142, 1)",
      cursor: "pointer",
    },
    iconContainer: {
      margin: "0",
      marginLeft: "8px",
      marginRight: "8px",
      position: "relative",
      width: "36px",
      height: "36px",
      display: "flex",
      alignItems: "center",
      backgroundColor: "#29baa4",
      borderRadius: "50%",
      cursor: "pointer",
    },
    searchIcon: {
      color: "white",
      backgroundColor: "#29baa4",
      marginLeft: `8px`,
      marginRight: "8px",
      borderRadius: "50%",
    },
    "@keyframes expand": {
      from: {
        transform: "scale(0,1)",
      },
      to: {
        transform: "scale(1,1)",
      },
    },
    "@keyframes shrink": {
      from: {
        transform: "scale(1,1)",
        visibility: "visible",
        width: "450px",
        height: "50px",
      },
      to: {
        transform: "scale(0,1)",
        visibility: "hidden",
        width: "450px",
        height: "50px",
      },
    },
  };
});
const SearchBar = () => {
  const history = useHistory();
  const classes = useStyles();
  const [showBar, setShowBar] = useState(false);
  const [firstShow, setFirstShow] = useState(true);
  const [search, setSearch] = useState("");
  const [rawInputForSearch, setRawInputForSearch] = useState("");
  const [focusedBar, setFocusedBar] = useState(false);
  const [focusedSearch, setFocusedSearch] = useState(false);
  const [recentSearches, setRecentSearches] = useState<string[]>([]);
  const [recentOpenedItems, setRecentOpenedItems] = useState<SearchResult[]>(
    []
  );
  const model = useAppContext((state) => state.model);
  const ctx = useAppContext();
  const createLink = useCreateLink();
  const user = useCurrentUser();
  const isTenantAdmin = user?.profile?.tenantAdmin === true;
  const hasAdminRole = Boolean(
    user?.profile?.role?.toLowerCase?.().includes("admin") ||
      user?.profile?.uiRole?.toLowerCase?.().includes("admin") ||
      user?.profile?.roles?.some((r) => r?.toLowerCase?.().includes("admin"))
  );
  const canSelectDivision = isTenantAdmin || hasAdminRole;
  const [periodOptions, setPeriodOptions] = useState<PeriodOption[]>([]);
  const [topElements, setTopElements] = useState<TopElementOption[]>([]);
  const extractYearFromPeriod = React.useCallback((periodName?: string): string => {
    if (!periodName) return "";
    const slashYearMatch = periodName.match(/\/\s*(\d{4})/);
    if (slashYearMatch?.[1]) return slashYearMatch[1];
    const yearAtEndMatch = periodName.match(/(20\d{2})$/);
    return yearAtEndMatch?.[1] || "";
  }, []);
  const parsePeriod = React.useCallback((periodName?: string) => {
    const safe = String(periodName || "");
    const slashMatch = safe.match(/(\d{1,2})\s*\/\s*(\d{4})/);
    if (slashMatch) {
      return { raw: safe, year: Number(slashMatch[2]), subPeriod: Number(slashMatch[1]) };
    }
    const year = Number(extractYearFromPeriod(safe));
    return { raw: safe, year: Number.isFinite(year) ? year : 0, subPeriod: 0 };
  }, [extractYearFromPeriod]);
  const [selectedYear, setSelectedYear] = useState(extractYearFromPeriod(ctx.period));
  const [yearToPeriod, setYearToPeriod] = useState<Record<string, string>>({});
  const [selectedDivisionId, setSelectedDivisionId] = useState<string>("");
  const LATEST_DONE_SEARCHES_STORAGE_KEY_NAME = `${ctx.modelId}::${
    ctx.language.split("-")[0]
  }::${user.profileId}::recentSearches`;
  const LATEST_OPENED_ITEMS_STORAGE_KEY_NAME = `${ctx.modelId}::${
    ctx.language.split("-")[0]
  }::${user.profileId}::searchResults`;
  const [] = useDebounce(
    () => {
      setSearch(rawInputForSearch);
    },
    500,
    [rawInputForSearch]
  );
  useEffect(() => {
    setSelectedYear(extractYearFromPeriod(ctx.period));
  }, [ctx.period, extractYearFromPeriod]);
  useEffect(() => {
    if (!showBar || !ctx.fullModelId) return;
    let mounted = true;
    const fetchPeriods = async () => {
      try {
        const response = await axios.post("meaquery", {
          query: `[${ctx.fullModelId}].periods`,
          attributes: "name",
          sortBy: "name",
          jsonmode: 1,
        });
        const rows = response?.data?.data;
        if (!mounted || !Array.isArray(rows)) return;
        const unique = Array.from(
          new Set(rows.map((r: any) => r?.name).filter(Boolean))
        ).map((name) => String(name));
        const sortedPeriods = [...unique].sort((a, b) => {
          const pa = parsePeriod(a);
          const pb = parsePeriod(b);
          if (pa.year !== pb.year) return pb.year - pa.year;
          if (pa.subPeriod !== pb.subPeriod) return pb.subPeriod - pa.subPeriod;
          return pb.raw.localeCompare(pa.raw);
        });
        const map: Record<string, string> = {};
        sortedPeriods.forEach((periodName) => {
          const year = extractYearFromPeriod(periodName);
          if (year && !map[year]) map[year] = periodName;
        });
        const years = Object.keys(map).sort((a, b) => Number(b) - Number(a));
        setYearToPeriod(map);
        setPeriodOptions(years.map((name) => ({ name })));
        if (years.length > 0 && !selectedYear) {
          setSelectedYear(years[0]);
        }
      } catch {
        if (mounted) setPeriodOptions([]);
      }
    };
    fetchPeriods();
    return () => {
      mounted = false;
    };
  }, [showBar, ctx.fullModelId, parsePeriod, extractYearFromPeriod, selectedYear]);
  useEffect(() => {
    if (!showBar || !canSelectDivision || !ctx.modelId) return;
    let mounted = true;
    const fetchTopElements = async () => {
      try {
        const response = await axios.get(`/workflow/topelements/SC.${ctx.modelId}`);
        const rows = response?.data?.data;
        if (!mounted || !Array.isArray(rows)) return;
        setTopElements(rows);
      } catch {
        if (mounted) setTopElements([]);
      }
    };
    fetchTopElements();
    return () => {
      mounted = false;
    };
  }, [showBar, canSelectDivision, ctx.modelId]);
  useEffect(() => {
    const getForage = async () => {
      let localRecentSearches: string[] | null = await localforage.getItem(
        LATEST_DONE_SEARCHES_STORAGE_KEY_NAME
      );
      let localRecentItems: SearchResult[] | null = await localforage.getItem(
        LATEST_OPENED_ITEMS_STORAGE_KEY_NAME
      );
      if (localRecentSearches) {
        setRecentSearches(localRecentSearches.slice(0, 5));
      } else {
        setRecentSearches([]);
      }
      if (localRecentItems) {
        setRecentOpenedItems(localRecentItems.slice(0, 5));
      } else {
        setRecentOpenedItems([]);
      }
    };
    getForage();
  }, [
    ctx.lastSearchUpdateTime,
    ctx.language,
    ctx.modelId,
    LATEST_DONE_SEARCHES_STORAGE_KEY_NAME,
    LATEST_OPENED_ITEMS_STORAGE_KEY_NAME,
  ]);
  const handleSearch = async (choice?: SearchResult) => {
    if (search.length >= 3) {
      const newRecentSearches = !recentSearches
        ? [search]
        : [search, ...recentSearches.filter((rec) => rec !== search)].slice(
            0,
            5
          );
      localforage.setItem(
        LATEST_DONE_SEARCHES_STORAGE_KEY_NAME,
        newRecentSearches
      );
      setRecentSearches(newRecentSearches);
      if (choice) {
        const newRecentOpenedItems = !recentOpenedItems
          ? [choice]
          : [
              choice,
              ...recentOpenedItems.filter((rec) => rec !== choice),
            ].slice(0, 5);
        localforage.setItem(
          LATEST_OPENED_ITEMS_STORAGE_KEY_NAME,
          newRecentOpenedItems
        );
        setRecentOpenedItems(newRecentOpenedItems);
      }
      const params = new URLSearchParams();
      const periodForSearch =
        yearToPeriod[selectedYear] ||
        ctx.period ||
        "";
      params.set("period", periodForSearch);
      if (canSelectDivision && selectedDivisionId) {
        params.set("division", selectedDivisionId);
      }
      history.push(`/tec/${model}/searchresults/${search}?${params.toString()}`);
    } else {
      alert(t("Search length should be greater or equal to 3"));
    }
  };
  const allPeriods = (
    periodOptions.length > 0
      ? periodOptions.map((period) => period.name)
      : [extractYearFromPeriod(ctx.period)].filter(Boolean)
  ) as string[];
  const selectedPeriod = yearToPeriod[selectedYear] || ctx.period || "";
  return (
    <>
      {showBar ? (
        <div className={classes.searchComponent}>
          <div
            className={`${classes.searchBar} ${
              focusedBar || search.length > 0 ? classes.typing : ""
            }`}
            onFocus={() => setFocusedBar(true)}
            onBlur={() => setFocusedBar(false)}
          >
            <input
              placeholder={t("Search")}
              className={classes.searchInput}
              onChange={(e) => setRawInputForSearch(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()}
            />
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              style={{ marginRight: "8px", border: "none", background: "transparent" }}
            >
              {allPeriods.map((periodName) => (
                <option key={periodName} value={periodName}>
                  {periodName}
                </option>
              ))}
            </select>
            {canSelectDivision && (
              <select
                value={selectedDivisionId}
                onChange={(e) => setSelectedDivisionId(e.target.value)}
                style={{
                  marginRight: "8px",
                  border: "none",
                  background: "transparent",
                  maxWidth: "140px",
                }}
              >
                <option value="">{t("All Divisions")}</option>
                {(topElements || []).map((top) => (
                  <option key={top.id} value={top.id}>
                    {mea_t("Name", top.JS_ATTR, ctx.language)}
                  </option>
                ))}
              </select>
            )}
            {search.length < 3 ? (
              <ClearIcon
                fontSize="large"
                className={classes.clearIcon}
                onClick={() => setShowBar(false)}
                onKeyDown={() => setShowBar(false)}
                aria-hidden="true"
              />
            ) : (
              <div className={classes.iconContainer}>
                <SearchIcon
                  fontSize="large"
                  className={classes.searchIcon}
                  onClick={() => handleSearch()}
                  onKeyDown={() => handleSearch()}
                  aria-hidden="true"
                />
              </div>
            )}
          </div>
          <div
            className={classes.resultsContainer}
            style={{
              visibility: focusedBar || focusedSearch ? "visible" : "hidden",
            }}
            onMouseEnter={() => setFocusedSearch(true)}
            onMouseLeave={() => setFocusedSearch(false)}
          >
            <div className={classes.results}>
              {search.length > 3 && (
                <SearchResults
                  handleSearch={handleSearch}
                  search={search}
                  setFocusedSearch={setFocusedSearch}
                  period={selectedPeriod}
                  divisionId={canSelectDivision ? selectedDivisionId : undefined}
                />
              )}
              <h3 className={classes.resultTitle}>
                {t("Recent Searches").toUpperCase()}
              </h3>
              {recentSearches.map((res, index, arr) => (
                <Link
                  to={`/tec/${ctx.modelId}/searchresults/${res}`}
                  onClick={() => setShowBar(false)}
                  className={
                    arr.length === index + 1 ? classes.linkContainer : ""
                  }
                  style={{ textDecoration: "none" }}
                >
                  <div className={classes.resultName}>{res}</div>
                </Link>
              ))}
              <h3 className={classes.resultTitle}>
                {t("Recently Opened Items").toUpperCase()}
              </h3>
              {recentOpenedItems.map((res) => (
                <div className={classes.recentOpenedItemsContainer}>
                  <Link
                    to={createLink(getElementTypePage(res))}
                    onClick={() => setShowBar(false)}
                    className={classes.recentOpenedItemsTextContainer}
                    style={{ textDecoration: "none" }}
                  >
                    <div className={classes.recentResultName}>
                      {mea_t("Name", res.JS_ATTR, ctx.language)}
                    </div>
                    <div className={classes.recentResultTitle}>
                      {tmodel(res.typename)}
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <>
          {!firstShow && <div className={classes.closingSearchBar} />}
          <IconButton
            onClick={() => {
              setShowBar(!showBar);
              setFirstShow(false);
            }}
            onKeyDown={() => {
              setShowBar(!showBar);
              setFirstShow(false);
            }}
            aria-hidden="true"
            className={classes.iconButton}
          >
            <img
              src={getFileApiURL("/icons/Search.svg")}
              alt="Search"
              style={{ filter: "brightness(0)" }}
            />
          </IconButton>
        </>
      )}
    </>
  );
};
export default SearchBar;
